import { ThemeProvider } from "@mui/material"
import CssBaseline from "@mui/material/CssBaseline"
import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import RouteList from "./components/routes/RouteList"
import store from "./redux/store"
import { injectStore } from "./services/api"
import theme from "./theme"
import updateLocale from "dayjs/plugin/updateLocale"
import weekday from "dayjs/plugin/weekday"
import ruRU from "dayjs/locale/ru"
import dayjs from "dayjs"
import isBetweenPlugin from "dayjs/plugin/isBetween"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers"

dayjs.extend(isBetweenPlugin)
dayjs.extend(updateLocale)
dayjs.updateLocale("ru", { weekStart: 1 })
dayjs.extend(weekday)

injectStore(store)

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ruRU} >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouteList />
        <ToastContainer />
      </ThemeProvider>
    </LocalizationProvider>
  </Provider>
)
